module.exports = __webpack_public_path__ + "static/media/family-md.6376f0ee.png";